import mddSvg from '../assets/MidSouth Development District.svg';

const MDDStorymap: React.FC = () => {
    return (
            <div className="p-12 max-w-5xl mx-auto">
                <img
                    src={mddSvg}
                    alt="MidSouth Development District"
                    className="w-full h-auto mb-6"
                />
                {/* <p className="mb-4 text-port-text">The MidSouth Development District is a quasi-government organization of city and county governments from West Tennessee, East Arkansas & North Mississippi. Governed by a Board of Directors made up of local elected officials, we serve six counties and thirty-eight cities. We provide a forum for the region to work together to advance social, economic and environmental progress.</p> */}

                <h2 className="text-2xl font-semibold mt-8 mb-2">YOUR STORY GOES HERE...</h2>           
            </div>
        );
};

export default MDDStorymap;